import BlankCouponDownload from '@components/blank/BlankCouponDownload';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import styled from '@emotion/styled';

import CouponFilter from './CouponFilter';
import DownloadAbleCoupon from './DownloadAbleCoupon';
import useDownloadAbleCoupons from './hooks/useDownloadAbleCoupons';

function DownloadCouponFragment() {
    const {
        coupons, sorter, setSorter, fetchNextPage, isBlank, isFetching,
    } = useDownloadAbleCoupons();
    return (
        <Column fullWidth>
            <CouponFilter sorter={sorter}
                setSorter={setSorter}/>
            <Container spacing={16} align='center' fullWidth>
                {isBlank && (
                    <BlankCouponDownload/>
                )}
                {coupons?.map((coupon) => (
                    <DownloadAbleCoupon coupon={coupon}
                        key={coupon.eventId}/>
                ))}
                <InfinityScrollTrigger trigger={fetchNextPage} />
                {isFetching && (
                    <Loading size='small'/>
                )}
            </Container>
        </Column>
    );
}

const Container = styled(Column)`
padding: 0 20px
`;

export default DownloadCouponFragment;
